import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import InquiryComments from './components/InquiryComments';
import InquiryFooter from './components/InquiryFooter';
import InquiryHeader from './components/InquiryHeader';
import ScrollTopButton from './components/ScrollTopButton';
import useInquiry from './hooks/useInquiry';

interface Params {
    inquiryId: string;
}

declare module '@stackflow/config' {
    interface Register {
        InquiryLogActivity: Params;
    }
}

const InquiryLogActivity: ActivityComponentType<'InquiryLogActivity'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId } = params;
    const { inquiry, isFetching } = useInquiry(inquiryId);
    // 종료된 문의는 추가 문의·종료를 할 수 없으므로 하단 버튼을 숨긴다
    const hasFooter = !!inquiry && inquiry.status !== 'CLOSED';
    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('header.title')} />}
                noFooterBorder
                footer={hasFooter ? <InquiryFooter inquiry={inquiry!}/> : undefined} >
                {inquiry && (
                    <Container>
                        <InquiryHeader inquiry={inquiry}/>
                        <InquiryComments inquiry={inquiry}/>
                        <ScrollTopButton hasFooter={hasFooter}/>
                    </Container>
                )}
                {isFetching && (<Loading/>)}
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled.div`
    width: 100%;
    min-height: 100%;
    position: relative;
`;

export default InquiryLogActivity;
